import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServerService } from './ServerService';

@Injectable({
  providedIn: 'root'
})
export class SessoesUsuarioService extends ServerService {

  constructor(http: HttpClient) {
    super(http);
  }

  public listeSessoes(empresa: any, idUsuario: number): Promise<any> {
    return super.obtenha('/registros-login/sessoes?e=' + empresa.id + '&uid=' + idUsuario, {});
  }

  public deslogarSessao(empresa: any, idSessao: string): Promise<any> {
    return super.facaPost('/registros-login/deslogue?sid=' + idSessao + '&eid=' + empresa.id, {});
  }

  public deslogarTodas(empresa: any, idUsuario: number): Promise<any> {
    return super.facaPost('/registros-login/deslogar-todas?uid=' + idUsuario + '&eid=' + empresa.id, {});
  }

  public buscarInformacoesLocalizacao(empresa: any, idSessao: string): Promise<any> {
    return super.obtenha('/registros-login/dados-localizacao?eid=' + empresa.id + '&sid=' + idSessao, {});
  }
}
